import request from "@/utils/request";

/**
 * 获取纸样工作室列表
 */
export const fetchPatternStudioList = (params) => request.get("/apc/index/patternStudio", params);

/**
 * 获取颜色列表
 */
export const fetchColorList = (params) => request.get("/apc/index/getColorList", params);

/**
 * 获取买手信息
 * @param {*} params
 * @returns
 */
export const fetchSelectBuyer = (params) => request.get("/apc/index/selectBuyer", params);

/**
 * 获取车版师信息
 * @param {*} params
 * @returns
 */
export const fetchCheBanShi = (params) => request.get("/apc/index/cheBanShi", params);

/**
 * 	获取用户信息
 * @param {*} params
 * @returns
 */
export const fetchSystemAdmin = (params) => request.get("/apc/index/systemAdmin", params);
/**
 * 获取尺码组列表
 */
export const fetchSizeGroupList = (params) => request.get("/apc/index/getSizeGroup", params);

/**
 * 获取尺码列表
 */
export const fetchBaseSizeList = (params) => request.get("/apc/index/sizeIndex", params);

/**
 * 获取部位量法列表
 */
export const fetchPartList = (params) => request.get("/apc/index/searchMeasurementPoint", params);

/**
 * 获取物料分类树列表
 */
export const fetchMaterialCategoryTree = (params) => request.get("/apc/base.materialCategory/tree", params);

/**
 * 获取选择物料列表
 */
export const fetchSelectBoardMaterialList = (params) => request.get("/apc/index/baseMaterial", params);

/**
 * 获取供应商列表
 */
export const fetchSupplierList = (params) => request.get("/apc/index/getSupplierList", params);

/**
 * 获取工艺模板列表
 */
export const fetchProcessTemplateList = (params) => request.get("/apc/board.board/baseProcessTemplate", params);

/**
 * 获取工艺模版详情
 */
export const fetchBaseProcessRead = (params) => request.get("/apc/board.board/baseProcessRead", params);

/**
 * 获取菜单数量统计
 */
export const fetchMenuMarkers = () => request.get("/apc/system.menuMarkers/getCount");

/**
 * 获取纸样工作室
 */
export const fetchPatternStudio = () => request.get("/apc/index/patternStudio");

/**
 * 获取车缝工价模版列表
 */
export const fetchTemplateBaseSewingList = (params, pageKey = "board") =>
	request.get(`/apc/board.${pageKey}/boardSewingAll`, params);

/**
 * 获取工艺制单工艺列表
 */
export const fetchBaseProcessList = (params) => request.get("/apc/board.board/baseProcessSheets", params);

/**
 * 挂起原因列表
 */
export const fetchHangUpReasonList = (params) => request.get("/apc/index/getEnum", params);

/**
 * 获取群英客户列表
 */
export const fetchCustomerList = (params) => request.get("/apc/index/getCustomerList", params);

/**
 * 获取基础物料列表
 * @description 以树形结构返回，里面包含了物料和子级供应商信息
 * @param {Object} params
 * @param {Number} params.material_category_id 物料类别id
 * @param {String} params.material_name_code 搜索关键字
 * @param {Number} params.page 页码
 * @param {Number} params.limit 每页数量
 */
export const fetchMaterialAndSupplier = (params) => request.get("/apc/board.board/getMaterialAndSupplier", params);

/**
 * 获取枚举列表
 */
export const fetchEnum = (params) => request.get("/apc/index/getEnum", params);

/**
 * 获取尺码组模板列表(无权限)
 */
export const fetchCommonSizeGroupTemplateList = (params) => request.get("/apc/index/sizeTemplateList", params);
